import { MessageModel } from "@/models/message";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const MAX_MESSAGE_HISTORY = 500;

interface State {
  messages: MessageModel[]; // list message group by date
  notification: any; // to do after
  last_message: MessageModel;
  eventsource_url: string;
  plan_type: "INTERACTIVE" | "SINGLE_STEP";
  additional_data: { file_guid_path?: string[]; is_auto_execution: boolean };
}

const defaultState: State = {
  messages: [],
  last_message: null,
  notification: null,
  plan_type: "INTERACTIVE",
  additional_data: { is_auto_execution: false },
  eventsource_url: ""
};

const trimMessages = (messages: MessageModel[]): MessageModel[] =>
  messages.length > MAX_MESSAGE_HISTORY ? messages.slice(-MAX_MESSAGE_HISTORY) : messages;

const fireBaseSlice = createSlice({
  name: "firebase",
  initialState: defaultState,
  reducers: {
    //push message to store. use when call api get messages
    pushMessages: (state, action: PayloadAction<{ message: MessageModel[] }>) => {
      state.messages = trimMessages(action.payload.message);
    },
    //add one message to chatbox. use when user handle submit message from chatbox
    addNewMessages: (state, action: PayloadAction<{ message: MessageModel[] }>) => {
      state.messages = trimMessages([...state.messages, ...action.payload.message]);
      // state.last_message = action.payload.message[action.payload.message.length - 1];
    },
    addEventsource: (state, action: PayloadAction<{ eventsource_url: string }>) => {
      state.eventsource_url = action.payload.eventsource_url;
    },
    clearMessage: (state) => {
      state.messages = [];
      state.eventsource_url = "";
      // state.additional_data = { is_auto_execution: false }; //break page edit
    },
    updateLoadingMessage: (
      state,
      action: PayloadAction<{
        messageInfo: {
          id: string;
          message: MessageModel;
        };
      }>
    ) => {
      const index = state.messages.findIndex((f) => f.id === action.payload.messageInfo.id);
      if (index >= 0) state.messages[index] = action.payload.messageInfo.message;
    },
    addAdditionalData: (state, action: PayloadAction<{ additional_data: object }>) => {
      state.additional_data = { ...state.additional_data, ...action.payload.additional_data };
    },
    addImageGuid: (state, action: PayloadAction<{ image_guid: string }>) => {
      if (!state.additional_data.file_guid_path) {
        state.additional_data.file_guid_path = [];
      }
      state.additional_data.file_guid_path.push(action.payload.image_guid);
    },
    handleAutoExecutionToggle: (state) => {
      if (!state.additional_data) {
        state.additional_data = { is_auto_execution: false };
      }
      state.additional_data.is_auto_execution = !state.additional_data?.is_auto_execution || false;
    },
    setAutoExecution: (state, action: PayloadAction<{ is_auto_execution: boolean }>) => {
      state.additional_data.is_auto_execution = action.payload?.is_auto_execution || false;
    },
    setPlanType: (state, action: PayloadAction<{ plan_type: "INTERACTIVE" | "SINGLE_STEP" }>) => {
      state.plan_type = action.payload?.plan_type || "INTERACTIVE";
    }
  }
});
export const {
  pushMessages,
  addNewMessages,
  clearMessage,
  updateLoadingMessage,
  addEventsource,
  addAdditionalData,
  addImageGuid,
  handleAutoExecutionToggle,
  setAutoExecution,
  setPlanType
} = fireBaseSlice.actions;
export default fireBaseSlice.reducer;
